import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import {updateTranslations} from "./i18n";
import mixins from "./mixins";
import request from "./request";
Vue.prototype.$http = request;
Vue.config.productionTip = false;

const main = async () =>
{
  await updateTranslations(process.env.VUE_APP_DEFAULT_CULTURE);
  
  new Vue({
    router,
    store,
    async mounted()
    {
      if(!this.countries.length)
      {
        const response = await this.$http.get(`/Country`);
        this.countries = response.data.countries;
      }

      if(!Object.keys(this.user).length)
      {
        try
        {
          const response = await this.$http.get(`/User`);
          this.user = response.data;
        }

        catch(error)
        {
          return;
        }
      }
    },
    render: h => h(App)
  }).$mount("#app");
}

main()